<template>
  <div style="margin:0px auto;overflow-y:hidden">
      <!--登录窗口-->
      <div class="ms-login">
        <div style="display:flex;margin-top:0px;background:#5cadee;width:100%">
          <img :src="imgSrc"  style="height:50px;width:70px" fit="scale-down"/>
          <div style="padding-left:20px;font-weight:600;font-size:16px;color:#fff;line-height:50px">简单 · 智能 · 高效 · 安全</div>
        </div>
        <!-- 表单区域 -->
        <van-cell-group  style="margin-top:10rem;" >
          <van-field
            v-model="upUser"
            @change="dbSelect"
            input-align="left"
            style="padding-left:6px;line-height:40px"
            placeholder="请输入用户名"
            :rules="[{ required: true, message: '请填写用户' }]" >
            <template #left-icon>
              <i class="iconfont icon-yonghu-yuan"></i>
            </template>
          </van-field>

          <van-field
            v-model="upPwd"
            type="password"
            input-align="left"
            style="padding-left:6px;line-height:40px"
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请填写密码' }]"  >
            <template #left-icon>
              <i class="iconfont icon-mima1"></i>
            </template>
          </van-field>

          <van-field
            v-model="form.corpid"
            is-link
            input-align="left"
            readonly
            style="padding-left:6px;line-height:40px"
            placeholder="请选择账套"
            @click="showDb = true">
            <template #left-icon>
              <i class="iconfont icon-zhangtaoguanli1"></i>
            </template>
          </van-field>
 

        </van-cell-group>
        <div style=" line-height:40px;display:flex;justify-content:center; margin:5px">
          <van-button square size="small" @click="normalLogin" type="primary" style="width:100%;height:40px;padding:1rem;margin-top:10rem; "><i class= "iconfont icon-denglu" style="margin-right:5px;"></i>登录</van-button>
        </div>
      </div>
      <!-- 请选择帐套 -->
      <van-popup v-model="showDb" round position="bottom" :style="{ maxHeight: '50%' }">
        <div class="popup-header">
          <div class="popup-title">选择账套</div>
        </div>
        <div class="popup-content">
          <van-cell-group>
            <van-cell
              @click="selRec(item)"
              v-for="(item, index) in dbArr"
              clickable
              :key="index"
              :title="item.CORPNM" 
              is-link>
            </van-cell>
          </van-cell-group>
        </div>
      </van-popup>
      
  </div>
</template>

<script>
const APP_VERSION = '1.0'
 
export default {
  name: "login",
  data() {
    return {
 
      form:{username:'',password:'',code:'',corpid:''},
      showDb: false,
      dbArr:[],
      validateKey:'',
 
      loading:false,
      v_corpid:'',
      imgSrc: require("@/assets/title.png"),
      rememberPassword: false,
      appVersion: APP_VERSION,
    };
  },
  components: {
 
  },
  mounted() {
      this.form.username = this.$cookies.get('v_telno') || localStorage.getItem('login_username') || ''
      this.form.password = localStorage.getItem('login_password') || ''
      this.dbSelect()
      this.form.corpid = this.$cookies.get('v_telcorpnm') || localStorage.getItem('login_corp_name') || ''
      this.v_corpid = this.$cookies.get('v_corpid') || localStorage.getItem('login_corpid') || ''
 
  },
  computed: {
    upUser:{
        get(){
            return this.form.username
        },
        set(val){
            this.form.username =val.toUpperCase() 
        }
    } ,
    upPwd:{
        get(){
            return this.form.password
        },
        set(val){
            this.form.password =val
        }
    } ,
 
  },
  methods: {
 
    selRec(item){
       this.form.corpid=item['CORPNM']
       this.v_corpid =item['IDSEQ']
       this.showDb =false
    },
    dbSelect(){
      if (this.form.username) {
        this.$axios({
            method: 'post',
            url: 'xuper_api/getBaseData',
            data: {p_key:'userno',p_value:this.form.username,p_key2:'stfg',p_value2:'Y', p_table:'V_SYS_DBDTL' },
        }).then(res=>{   
            this.dbArr =res.result
        })
      }
    },
    exitBtn(){
      this.$emit('child-exit')
    }  ,
    cfmBtn(){
      
      this.$emit('child-sure' )
    }  ,
    //登录
    async normalLogin(){
      if (!this.form.username){
        this.$toast({type:'fail',message: '用户名不能为空'})
      }else if (!this.form.password){
        this.$toast({type:'fail',message: '密码不能为空'})
      } else if (!this.v_corpid){
        this.$toast({type:'fail',message: '账套不能为空'})
      } else {
        const loadingToast = this.$toast.loading({
            message: '加载中...',
            forbidClick: true,    // 禁止背景点击
            duration: 0,          // 持续展示，不自动关闭
            loadingType: 'spinner' // loading 样式
        })
        try{
          //登录验证
          await this.$axios({
              method:'post',
              url: 'xuper_api/loginValid' ,
              data:{  //get这里应为params //请求参数
                  password :this.form.password,
                  username :this.form.username,
                  p_key:'XUPE',
                  corpid: this.v_corpid,
              },
          }).then(res =>{
              if (res.code === '200'){
                localStorage.setItem('login_username', this.form.username)
                localStorage.setItem('login_password', this.form.password)
                localStorage.setItem('login_corpid', this.v_corpid)
                localStorage.setItem('login_corp_name', this.form.corpid)
                // 认证改由 HttpOnly Cookie 维持。
                this.$cookies.set('v_usernm',res.usernm); //用户名称
                this.$cookies.set('v_telno',res.userno); //用户账号
                this.$cookies.set('v_teluser',res.userno); //用户编码
                this.$cookies.set('v_telusernm',res.usernm); //用户名称
                this.$cookies.set('v_deptnm',res.deptnm); //用户名称
                this.$cookies.set('v_corpid',this.v_corpid); //当前账套
                this.$cookies.set('v_telcorpnm',this.form.corpid);
                this.$cookies.set('v_idseq',res.idseq); //用户序号

                localStorage.setItem('v_telno',res.userno); //用户账号
                localStorage.setItem('v_usernm',res.usernm); //用户名称
                localStorage.setItem('v_idseq',res.idseq); //用户序号
                localStorage.setItem('v_deptnm',res.deptnm)
                localStorage.setItem('v_telcorpnm',this.form.corpid)
                
                this.$router.push({path:'/features'})
                this.$emit('child-result','ok')               
              }else{
                  this.$toast({type:'fail',message: res.result})
                  this.$emit('child-result','error')
              }
          })
        }finally {
            loadingToast.clear()
        }  
      }
    },
 
 
  },
  
};
</script>
<style lang="scss" scoped>
 
.ms-login {
      position: relative;
      left:5%;
      margin-top:45%;
      width:90%;
      border-radius: 5px;
      background: white;//#f0f8ff;
      overflow: hidden;
  } 

.popup-header {
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid #F0F0F0;
  
  .popup-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
}

.popup-content {
  max-height: 400px;
  overflow-y: auto;
  
  ::v-deep .van-cell {
    font-size: 14px;
    
    &:active {
      background-color: #F5F7FA;
    }
  }
}
</style>
 
